import { render, staticRenderFns } from "./IBKNGReadAloud.vue?vue&type=template&id=1b37bd6b"
import script from "./IBKNGReadAloud.vue?vue&type=script&lang=ts"
export * from "./IBKNGReadAloud.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports